import { render, staticRenderFns } from "./razdelObmen.vue?vue&type=template&id=ff605920&scoped=true&"
import script from "./razdelObmen.vue?vue&type=script&lang=js&"
export * from "./razdelObmen.vue?vue&type=script&lang=js&"
import style0 from "./razdelObmen.vue?vue&type=style&index=0&id=ff605920&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff605920",
  null
  
)

export default component.exports